const margemBruta = {
  id: "margem-bruta",
  titulo: "Margem Bruta",
  pathModulo: "/margem-bruta",
  icone: "FileSpreadsheet",
  allowedRoles: [
    "admin",
    "financeiro",
    "diretor",
    "administracao",
    "OPERACAO",
    "ASSISTENTEOPERACAO",
    "GESTOR_ESTRATEGICO",
  ],
  descricao:
    "Painel consolidado da margem bruta por projeto, cruzando faturamento (NFe), mão de obra, custos operacionais e competência. Permite comparar os valores Realizados com o Orçado, projeto a projeto.",
  passoAPasso: [
    {
      titulo: "Filtre os dados",
      texto:
        "No topo da tela, use os filtros de Projeto, Prestador de Serviço, Gerente de Projetos, Mês DRE e Ano para restringir a análise ao recorte que você precisa. Os filtros aceitam múltipla seleção.",
    },
    {
      titulo: "Limpe os filtros quando precisar recomeçar",
      texto:
        "O botão \"Limpar Filtros\" (ao lado dos filtros) remove todas as seleções e volta a exibir todos os projetos do período padrão.",
    },
    {
      titulo: "Ative a comparação com o orçado",
      texto:
        "Marque a opção \"Comparar com orçado\" para exibir o Resumo Executivo (projetos acima e abaixo do orçamento) e a tabela \"Comparativo Real x Orçado por Projeto\", com as colunas Faturamento Bruto, Faturamento Líquido, Mão de Obra, Custo Operacional, Margem Bruta Revisão e % Margem Bruta Revisão — cada uma dividida em Real, Orçado e Diferença.",
    },
    {
      titulo: "Ordene as tabelas",
      texto:
        "Clique nos cabeçalhos das colunas (ícone de seta) para ordenar a tabela por Projeto, Real, Orçado ou Diferença, em ordem crescente ou decrescente.",
    },
    {
      titulo: "Alterne entre tema claro e escuro",
      texto:
        "Use o botão de sol/lua no cabeçalho para trocar a paleta de cores da tela conforme sua preferência.",
    },
  ],
  dicas: [
    "Use os filtros de Mês DRE e Ano juntos para analisar um período fechado (ex.: apenas o 1º trimestre de 2026).",
    "A comparação Real x Orçado só fica visível fora da visão reduzida de \"Faturamento por Projeto\" usada pelos GPs — se você não vir a opção, confirme que está na tela completa de Margem Bruta.",
    "Ao investigar uma queda de margem em um projeto específico, filtre por ele isoladamente e observe separadamente Mão de Obra e Custo Operacional — a diferença costuma estar em um dos dois.",
  ],
  faq: [
    {
      pergunta: "De onde vêm os dados de Margem Bruta?",
      resposta:
        "O painel combina automaticamente dados de faturamento (NFe), lançamentos financeiros, mão de obra e competência de cada projeto. Não é necessário nenhum lançamento manual nesta tela.",
    },
    {
      pergunta: "Por que um projeto some da lista ao aplicar um filtro?",
      resposta:
        "Isso significa que nenhum registro do projeto atende a todos os filtros selecionados simultaneamente (ex.: o projeto não teve movimentação no mês/ano escolhido).",
    },
    {
      pergunta: "O que representa a coluna \"Dif.\" no comparativo Real x Orçado?",
      resposta:
        "É a diferença entre o valor Real e o Orçado. Em colunas de custo (Mão de Obra, Custo Operacional) o cálculo é invertido, já que um custo real menor que o orçado é positivo para a margem.",
    },
  ],
};

export default margemBruta;
